import { useMutation, MutationOptions, useQuery } from 'react-query'
import { api } from '../../utils/api'
import { UserLoginParam, UserTokenType, UserLoginParamAD, BuzzebeesLoginProps, BuzzebeesLoginResponse } from './auth-types'
import { setUser } from '../user/user-query'
import { setShowModalDownloadHealthCheckupDetail, setShowModalDownloadInsuranceDetail, setToken } from '../../utils/helper'
import { ContentType } from '../../utils/api/tools'

export const AUTH_URL = '/api/auth'
export const LOGIN_URL = `${AUTH_URL}/login`
export const LOGIN_URL_AD = `/api/auth/azure/verify`
export const LOGIN_TYPE = '/api/loginType'
export const BUZZEBEES_MARKETPLACE_URL = '/auth/login'

export const useLoginType = () => {
  return useQuery(LOGIN_TYPE, async () => {
    return await api.belive.get<number>(LOGIN_TYPE)
  })
}

export const useLoginAD = (
  option?: MutationOptions<UserTokenType, { message: string }, UserLoginParamAD>,
) => {
  const { onSuccess } = option || {}

  return useMutation(
    async (data: UserLoginParamAD) => {
      return api.belive.post<UserTokenType>(LOGIN_URL_AD, data, {
        contentType: ContentType.JSON,
      })
    },
    {
      onSuccess: (data, variables, context) => {
        setToken(data.token.hash)
        setUser(data.user)
        onSuccess && onSuccess(data, variables, context)
      },
      ...option,
    },
  )
}

export const useLogin = (
  option?: MutationOptions<UserTokenType, { message: string }, UserLoginParam>,
) => {
  const { onSuccess } = option || {}

  return useMutation(
    async (data: UserLoginParam) => {
      return api.belive.post<UserTokenType>(LOGIN_URL, { ...data, by_pass: true })
    },
    {
      onSuccess: (data, variables, context) => {
        setToken(data.token.hash)
        setUser(data.user)
        onSuccess && onSuccess(data, variables, context)
        setShowModalDownloadInsuranceDetail('show')
        setShowModalDownloadHealthCheckupDetail('show')
      },
      ...option,
    },
  )
}

export const useBuzzebeesLogin = () => {
  return useMutation(
    async (data: BuzzebeesLoginProps) => {
      return api.buzzebees.post<BuzzebeesLoginResponse>(BUZZEBEES_MARKETPLACE_URL, data, {
        contentType: ContentType.JSON,
        headers: {
          Authorization: "token .WmlUFW25P9OpEPaZegZS_rOxaFHIcIcegmSUrcIAY0yXgiaI8Aq9pAQPpzcVDGAGmX2h_SGHPYPgc4PrXzvHBk-gumTA1qZpM_y60aK3qslqUTC52pF8ArypJWDEI7Is4mCLb7EsAlumSdcgFAu3v5xe_i8tii1OpU1bTzLu__8RxGKDkdKmkqjNSJGJlVhg"
        }
      })
    },
    {
      onSuccess(data, variables, context) {
        console.log(data)
      },
      onError: (e: any) => {
        if (e.message) {
          console.log(e.message)
        }
      },
    }
  )
}